import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DrupalService } from 'src/app/services/drupal.service';
import { getStyle, stringSubstr } from 'src/app/utils.ts/helpers';

@Component({
  selector: 'app-news-loader',
  templateUrl: './news_loader.component.html',
  styleUrls: ['./news_loader.component.scss']
})
export class NewsLoaderComponent implements OnInit {

  constructor(private drupalService: DrupalService) { }

  @Input() data: any;
  @ViewChild('top') scrollToTop: ElementRef | undefined;

  allNews: any[] = [];
  currentPage: number = 1;
  totalPages: number = 0;
  pageLimit: number = 6;
  isLoading: boolean = true;
  paginatorVisible: boolean = true;

  getImage = getStyle;
  stringSubstr = stringSubstr

  ngOnInit(): void {
    this.data.news_loader_news = Array.isArray(this.data.news_loader_news) ? this.data.news_loader_news.filter((item: any) => item.status === true) : [];
    this.drupalService.getAllByType('', 'news', 'news_image.field_media_image,news_type', this.currentPage - 1).subscribe((data: any) => {
      this.allNews = data.data;
      this.totalPages = Math.ceil(data.meta.count / this.pageLimit)
      this.isLoading = false;
    })
  }

  onPageChange(page: number) {
    this.isLoading = true;
    this.scrollToTop?.nativeElement.scrollIntoView({ behavior: "smooth" });
    this.drupalService.getAllByType('', 'news', 'news_image.field_media_image,news_type', (page - 1) * this.pageLimit).subscribe((data: any) => {
      this.currentPage = page;
      this.allNews = data.data;
      this.totalPages = Math.ceil(data.meta.count / this.pageLimit)
      this.isLoading = false;
    });
  }

  onSearch(term: string) {
    if (term === '') {
      this.paginatorVisible = true;
      return this.ngOnInit()
    }
    this.drupalService.ESQuerySearch('news', {
      "from": 0,
      "size": 30,
      "query": {
        "bool": {
          "must": [
            ...(term ? [{
              "multi_match": {
                "query": term,
                "type": "phrase_prefix",
                "fields": [
                  "data.title^50",
                  "*"
                ]
              }
            }] : []),
            ...(this.data.status ? [{ "term": { "data.status": true } }] : []),
          ]
        }
      }
    }
    ).subscribe({
      next: (data: any) => {
        this.allNews = data.hits.hits.map((item: any) => {
          this.paginatorVisible = false;
          this.isLoading = false;
          return item.data
        });
      },
      error: console.error
    });
  }
}
